import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Timeline from '../../components/Timeline/Timeline';

import Toni from '../../assets/images/ToniDespre.png';

import './Despre.css';

export default function Despre() {
    return (
        <Container className="worldwide" style={{paddingTop: "75px"}}>
            <div className="header-text">
                <p className="despreTitle">
                    <span className="bracket">{'<'}</span>
                    Despre
                    <span className="bracket">{'/>'}</span>
                </p>
                <p className="despreSubTitle">
                    Află mai multe despre mine și despre tot parcursul meu profesional
                </p>
            </div>
            <Row className="despre-row">
                <Col lg={4} className="text-center d-flex align-items-center justify-content-center">
                    <img src={Toni} className="despreImage" alt="Avatar"/>
                </Col>
                <Col lg={8}>
                    <div className="despre-info">
                        <p className="despreTitle2">Crantea Antonio-Cristian</p>
                        <p className="despreSubTitle2">Profesor Inginer de Informatică și TIC, Asistent Universitar Voluntar, Programator și Autor</p>
                        <p className="despreDescription">
                            Eu sunt Toni și sunt un tânăr pasionat de Informatică, Tehnologie și Educație. De-a lungul
                            anilor am încercat să ating diferite obiective, iar majoritatea chiar mi-au ieșit, precum
                            obținerea notelor 9.90 la Matematică și 10 la Informatică în cadrul Bacalaureatului, faptul
                            că am urmat o facultate de top în inginerie, sau că în prezent lucrez la diferite proiecte
                            educaționale.
                        </p>
                        <p className="despreDescription">
                            Începând cu anul 2020 am început să ofer meditații / pregătiri individuale copiilor
                            pentru pregătirea școlară, examenul de Bacalaureat, admiteri la facultățile de top, iar mai
                            nou și pentru Olimpiadă, ulterior înființând și o{' '}
                            <a href="https://edeea.ro/produs/pachet-agenda-informatica-set-memoratoare-caiet-informatica/" target="blank">
                            agendă educațională</a> la disciplina Informatică.
                        </p>
                        <p className="despreDescription">
                            În toamna anului 2024 am devenit oficial profesor de Informatică și TIC, în prezent
                            continuând să fac asta, iar în luna decembrie a anului 2025, am reușit să creez și un{' '}
                            <a href="https://i-scoala.ro/curs-informatica-pentru-bacalaureat/" target="blank">
                            curs online</a> special pentru examenul de Bacalaureat la Informatică.
                        </p>
                        <p className="despreDescription">
                            Și povestea mea abia a început...
                        </p>
                    </div>
                </Col>
            </Row>
            <Row className="timeline-row">
                <div className="timeline-wrapper">
                    <Timeline/>
                </div>
            </Row>
        </Container>
    );
}